import React from 'react';
import { Box, Typography, Chip } from '@material-ui/core';
import { Close as ClearIcon } from '@material-ui/icons';
import { ProcessedMilestone } from '../types';
import { millisecondsToTimePeriod } from '../../../utils/time-helper';

interface MilestoneTimeDiffProps {
  selectedMilestones: ProcessedMilestone[];
  onClear: () => void;
}

export const MilestoneTimeDiff = React.memo(({ selectedMilestones, onClear }: MilestoneTimeDiffProps) => {
  const timeDifference = React.useMemo(() => {
    if (selectedMilestones.length !== 2) return null;
    
    const [first, second] = selectedMilestones;
    
    if (!first.timestamp || !second.timestamp) return null;
    
    const firstTime = new Date(first.timestamp).getTime();
    const secondTime = new Date(second.timestamp).getTime();
    const diffMs = Math.abs(secondTime - firstTime);
    
    const { days, hours, minutes } = millisecondsToTimePeriod(diffMs);
    
    let result = '';
    if (days > 0) result += `${days}d `;
    if (hours > 0) result += `${hours}h `;
    if (minutes > 0) result += `${minutes}m`;
    
    return result.trim() || '< 1m';
  }, [selectedMilestones]);

  if (selectedMilestones.length === 0) return null;

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginRight: 16 }}>
      <Typography variant="body2" style={{ color: '#666' }}>
        Selected: {selectedMilestones.length}/2
      </Typography>
      {timeDifference && (
        <Chip
          label={`Time Difference: ${timeDifference}`}
          color="primary"
          size="medium"
          onDelete={onClear}
          deleteIcon={<ClearIcon />}
          style={{ 
            fontSize: '14px', 
            fontWeight: 600,
            backgroundColor: '#1976d2',
            color: 'white'
          }}
        />
      )}
    </Box>
  );
});
